/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Service_WorkersInputs */

const en_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service workers`)
};

const ar_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمال الخدمة`)
};

const bn_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্ভিস ওয়ার্কার`)
};

const de_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicemitarbeiter`)
};

const es_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajadores de servicios`)
};

const fr_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travailleurs des services`)
};

const pt_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhadores de serviço`)
};

const zh_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务人员`)
};

const tr_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet çalışanları`)
};

const ru_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работники сферы обслуживания`)
};

const pl_svchip_service_workers = /** @type {(inputs: Svchip_Service_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracownicy usług`)
};

/**
* | output |
* | --- |
* | "Service workers" |
*
* @param {Svchip_Service_WorkersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_service_workers = /** @type {((inputs?: Svchip_Service_WorkersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Service_WorkersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_service_workers(inputs)
	if (locale === "bn") return bn_svchip_service_workers(inputs)
	if (locale === "de") return de_svchip_service_workers(inputs)
	if (locale === "es") return es_svchip_service_workers(inputs)
	if (locale === "fr") return fr_svchip_service_workers(inputs)
	if (locale === "pt") return pt_svchip_service_workers(inputs)
	if (locale === "zh") return zh_svchip_service_workers(inputs)
	if (locale === "tr") return tr_svchip_service_workers(inputs)
	if (locale === "ru") return ru_svchip_service_workers(inputs)
	if (locale === "pl") return pl_svchip_service_workers(inputs)
	return en_svchip_service_workers(inputs)
});